import {
  DOMAIN_FETCH_SUCCESS,
  DOMAIN_FETCH_FAIL,
  DOMAIN_FETCH_BY_NAME_FAIL,
  DOMAIN_FETCH_BY_NAME_SUCCESS,
  DOMAIN_TRANSFER_FETCH_SUCCESS,
  DOMAIN_TRANSFER_FETCH_FAIL,
  DOMAIN_EXPIRED_FETCH_SUCCESS,
  DOMAIN_EXPIRED_FETCH_FAIL
} from '../constant/actionType';

import logger from '../util/logger';

export const initialState = {
  domainExpired: [],
  domainStore: {},
  domainTransfers: [],
  domains: [],
  isDoaminTransfersFailed: false,
  isDomainExpiredFailed: false,
  isDomainExpiredLoaded: false,
  isDomainFailed: false,
  isDomainLoaded: true,
  isDomainTransfersLoaded: false,
  isFailed: false,
  isLoaded: false
};

const domainReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case DOMAIN_FETCH_SUCCESS: {
      logger.debug(`${DOMAIN_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      const { domains } = data;

      return {
        ...state,
        domains,
        isFailed: false,
        isLoaded: true
      };
    }

    case DOMAIN_FETCH_FAIL: {
      logger.debug(`${DOMAIN_FETCH_FAIL}`);

      return { ...state, isFaled: true, isLoaded: true };
    }

    case DOMAIN_FETCH_BY_NAME_SUCCESS: {
      logger.debug(`${DOMAIN_FETCH_BY_NAME_SUCCESS}: ${JSON.stringify(data)}`);

      const { domain } = data;
      const { name } = domain;

      const domainStore = {
        ...state.domainStore,
        [name]: domain
      };

      return {
        ...state,
        domainStore: { ...domainStore },
        isDomainFailed: false,
        isDomainLoaded: true
      };
    }

    case DOMAIN_FETCH_BY_NAME_FAIL: {
      logger.debug(`${DOMAIN_FETCH_BY_NAME_FAIL}`);

      return { ...state, isDomainFailed: false, isDomainLoaded: true };
    }

    case DOMAIN_TRANSFER_FETCH_SUCCESS: {
      logger.debug(`${DOMAIN_TRANSFER_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      const { domainTransfers } = data;

      return {
        ...state,
        domainTransfers,
        isDoaminTransfersFailed: false,
        isDomainTransfersLoaded: true
      };
    }

    case DOMAIN_TRANSFER_FETCH_FAIL: {
      logger.debug(`${DOMAIN_FETCH_FAIL}`);

      return { ...state, isDoaminTransfersFailed: true, isDomainTransfersLoaded: true };
    }

    case DOMAIN_EXPIRED_FETCH_SUCCESS: {
      logger.debug(`${DOMAIN_EXPIRED_FETCH_SUCCESS}: ${JSON.stringify(data)}`);

      const { domains } = data;

      return {
        ...state,
        domainExpired: domains,
        isDomainExpiredFailed: false,
        isDomainExpiredLoaded: true
      };
    }

    case DOMAIN_EXPIRED_FETCH_FAIL: {
      logger.debug(`${DOMAIN_EXPIRED_FETCH_FAIL}`);

      return { ...state, isDomainExpiredFailed: true, isDomainExpiredLoaded: true };
    }

    default:
      return state;
  }
};

export default domainReducer;
